export default __webpack_public_path__ + "static/brasil-99c41be9d6f55b83a35a9095ce28965b.png";